import { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";

const FloatingWhatsApp = () => {
  const [visible, setVisible] = useState(false);

  const handleScroll = useCallback(() => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const threshold = window.innerHeight * 0.8;
    setVisible(scrollTop > threshold);
  }, []);

  useEffect(() => {
    // Check immediately
    handleScroll();

    // Use multiple event sources for maximum compatibility
    window.addEventListener("scroll", handleScroll, { passive: true });
    document.addEventListener("scroll", handleScroll, { passive: true });

    // Also use a periodic check as ultimate fallback for mobile
    const interval = setInterval(handleScroll, 1000);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("scroll", handleScroll);
      clearInterval(interval);
    };
  }, [handleScroll]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href="https://wa.me/447702696253"
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-6 left-6 z-50 flex md:hidden items-center justify-center w-14 h-14 bg-green-600 text-white rounded-full shadow-lg hover:bg-green-700 transition-colors"
          aria-label="Message me on WhatsApp"
        >
          <FaWhatsapp className="w-7 h-7" />
        </motion.a>
      )}
    </AnimatePresence>
  );
};

export default FloatingWhatsApp;
